import React from 'react';
import './MetadataTypeNav.css';

export default function MetadataTypeNav({ types, activeTypeId, onSelect }) {
  return (
    <nav className="metadata-type-nav" aria-label="Metadata categories">
      <p className="metadata-type-nav-label">Categories</p>
      <ul className="metadata-type-nav-list">
        {types.map((type) => {
          const Icon = type.icon;
          const isActive = type.id === activeTypeId;
          return (
            <li key={type.id}>
              <button
                type="button"
                className={`metadata-type-nav-item${isActive ? ' active' : ''}`}
                onClick={() => onSelect(type.id)}
                aria-current={isActive ? 'page' : undefined}
              >
                {Icon && <Icon className="metadata-type-nav-icon" aria-hidden />}
                <span className="metadata-type-nav-text">{type.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
      <p className="metadata-type-nav-hint">
        More metadata categories can be added here as your organization grows.
      </p>
    </nav>
  );
}
